import Vue from 'vue'

const proto = Vue.prototype

export default {
  getJwtClaim (token, key) {
    let claim = token ? this.parseJWTToken(token)[key] : null
    return claim
  },
  parseJWTToken (token) {
    let base64Url = token.split('.')[1]
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
    return JSON.parse(jsonPayload)
  },
  getClosestVueParent ($parent, cssClass) {
    if (!$parent || !$parent.$el) {
      return false
    }
    if ($parent._uid === 0) {
      return false
    }
    if ($parent.$el.classList.contains(cssClass)) {
      return $parent
    }
    return this.getClosestVueParent($parent.$parent, cssClass)
  },
  debounce (func, params, delay, timeOut) {
    let args = params ? params : arguments
    let callFunction = function () {
      func.apply(null, [args])
    }
    if (timeOut) {
      clearTimeout(timeOut)
    }
    let timeOutId = setTimeout(() => {
      callFunction()
    }, delay)
    return timeOutId
  },
  concatArrayWithCommaAndGetProp (array, name) {
    if (array.length === 1) {
      return array[0][name]
    }

    var and = this.getTranslateOfAnd()

    return [array.slice(0, -1).map(function(elem){
      return elem[name];
    }).join(', '), array.slice(-1)[0][name]].join(array.length < 2 ? '' : ` ${and} `)
  },
  concatArrayWithComma (array) {
    if (!array || array.length === 0 || array.filter(v => !!v).length === 0) {
      return '-'
    }

    if (array.length === 1) {
      return array[0]
    }
    
    var and = this.getTranslateOfAnd()

    return [array.slice(0, -1).map(function(elem){
      return elem;
    }).join(', '), array.slice(-1)[0]].join(array.length < 2 ? '' : ` ${and} `)
  },
  handleDownload (blob, filename) {
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    a.click()
    URL.revokeObjectURL(url)
  },
  getTranslateOfAnd () {
    var currentLocation = proto.$languages().locale
    var currentLanguage = proto.$languages().messages[currentLocation]
    return currentLanguage.and.toLowerCase()
  }
}
